import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";

function ModalAddIACredits({ show, onHide, iaTokensValue = 0, onSubmit }) {
  const { register, handleSubmit, setValue } = useForm();
  const [displayValue, setDisplayValue] = useState("");

  const formatCurrency = (value) => {
    const numericValue = value.replace(/\D/g, "");
    const floatValue = parseFloat(numericValue) / 100;

    if (isNaN(floatValue)) return "";
    return floatValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleChange = (e) => {
    const rawValue = e.target.value;

    const maskedValue = formatCurrency(rawValue);
    setDisplayValue(maskedValue);

    const numericValue = Number(rawValue.replace(/\D/g, "")) / 100;

    setValue("ia_tokens_balance", numericValue, { shouldValidate: true });
  };

  const submitHandler = (data) => {
    onSubmit({
      ...data,
      ia_tokens_balance: data.ia_tokens_balance,
    });
  };

  return (
    <Modal show={show} onHide={() => onHide()} size="xs" scrollable>
      <Modal.Header closeButton className="modalGradient">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="text-white"
        ></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {iaTokensValue <= 0 ? (
          <>
            <h4 className="title-modal-tools text-center mb-0">
              Seu saldo acabou!
            </h4>
            <h4 className="title-modal-tools text-center mb-4">
              Adicione mais para continuar.
            </h4>
          </>
        ) : (
          <>
            <h4 className="title-modal-tools text-center mb-0">
              Seu saldo está acabando...
            </h4>
            <h4 className="title-modal-tools text-center mb-4">
              Adicione mais para continuar.
            </h4>
          </>
        )}
        <Form onSubmit={handleSubmit(submitHandler)}>
          <div className="container">
            <div className="content-btns-modal-tools">
              <div className="btn-modal-tools">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Adicionar saldo de (R$): "
                  >
                    <Form.Control
                      {...register("ia_tokens_balance")}
                      name="ia_tokens_balance"
                      type="text"
                      className="form-control"
                      value={displayValue}
                      onChange={handleChange}
                    />
                  </FloatingLabel>
                </div>

                <div className="d-flex">
                  <Button
                    className="d-flex justify-content-center shadow-sm fs-6 p-2 rounded-2 fw-normal text-white"
                    style={{ backgroundColor: "#222222" }}
                    type="submit"
                  >
                    <i className="bi bi-robot"></i>
                    &nbsp; Comprar IA saldo
                  </Button>
                </div>
                <div className="modal-tools-information">
                  <i className="bi bi-info-circle"></i>
                  &nbsp;
                  <p>
                    Ao clicar em <b>"Comprar IA saldo"</b>, sua solicitação será
                    enviada para a equipe de administração. Eles entrarão em
                    contato pelo e-mail ou celular cadastrado em sua conta para
                    concluir a adição dos créditos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ModalAddIACredits;
